import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { BrandedCard, BrandedHeader, BrandedAlert } from '../branding/BrandedComponents';
import { SignInForm } from './SignInForm';
// AdminSecurityNotice intentionally not shown on login to keep UI clean

interface SignInPageProps {
  onSignInSuccess?: () => void;
  onSwitchToSignUp?: () => void;
  onForgotPassword?: () => void;
}

export const SignInPage: React.FC<SignInPageProps> = ({
  onSignInSuccess,
  onSwitchToSignUp,
  onForgotPassword
}) => {
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (email: string, password: string) => {
    setError(null);
    setLoading(true);

    try {
      await signIn(email, password);
      console.log('Sign in successful');
      onSignInSuccess?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-brand-background">
      <BrandedCard className="w-full max-w-md border" padding="large">
        <BrandedHeader size="large" showTagline={false} />

        {error && (
          <BrandedAlert className="mb-6" variant="error">
            {error}
          </BrandedAlert>
        )}

        <SignInForm
          onSubmit={(email, password) => handleSubmit(email, password)}
          loading={loading}
          onForgotPassword={onForgotPassword}
        />

        <div className="mt-6 text-center text-brand-secondary">
          <p className="text-sm">
            Don't have an account?{' '}
            <button onClick={onSwitchToSignUp} className="font-medium text-brand">
              Sign up here
            </button>
          </p>
        </div>
      </BrandedCard>
    </div>
  );
};